/*
 *
 * ItineraryPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'itineraryPage';
export const initialState = {
    is404: false,
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    itineraryActivities: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        hasMore: true,
        offset: 0,
        list: [],
        promoPrices: [],
        // seo-friendly-array-from-ssr
        preloaded: [],
        isPreloadedVisible: false,
        total: 0,
    },
    categoryActivities: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        hasMore: true,
        offset: 0,
        list: [],
        promoPrices: [],
        // seo-friendly-array-from-ssr
        preloaded: [],
        isPreloadedVisible: false,
        total: 0,
    },
    destinationActivities: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        hasMore: true,
        offset: 0,
        list: [],
        promoPrices: [],
        // seo-friendly-array-from-ssr
        preloaded: [],
        isPreloadedVisible: false,
        total: 0,
    },
    recommends: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: [],
    },
    query: {
        from: 0,
        to: 0,
    },
    params: {
        slug: '',
    },
    userImages: {
        res: [],
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
    },
};

/* eslint-disable no-param-reassign, default-case */
function itineraryPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_QUERY:
                draft.query = action.query;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            // Page
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            // Itinerary Activities
            case ActionTypes.SET_ITINERARY_PRELOADED:
                draft.itineraryActivities.preloaded = action.preloaded.items;
                draft.itineraryActivities.isPreloadedVisible = action.preloaded.isVisible;
                draft.itineraryActivities.total = action.preloaded.total;
                return draft;
            case ActionTypes.FETCH_ITINERARY_ACTIVITIES_STARTED:
                draft.itineraryActivities.isLoading = true;
                draft.itineraryActivities.isError = false;
                draft.itineraryActivities.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_ITINERARY_ACTIVITIES_SUCCESSFULLY:
                draft.itineraryActivities.isLoading = false;
                draft.itineraryActivities.isLoaded = !action.res.hasMore;
                draft.itineraryActivities.list = action.res.items;
                draft.itineraryActivities.offset = action.res.offset;
                draft.itineraryActivities.hasMore = action.res.hasMore;
                return draft;
            case ActionTypes.FETCH_ITINERARY_ACTIVITIES_FAILED:
                draft.itineraryActivities.isLoading = false;
                draft.itineraryActivities.isError = true;
                draft.itineraryActivities.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_ITINERARY_ACTIVITIES_CANCELLED:
                draft.itineraryActivities.isLoading = false;
                return draft;
            // case ActionTypes.SET_ITINERARY_ACTIVITIES_IS_LOADED:
            //     draft.itineraryActivities.isLoaded = action.isLoaded;
            //     return draft;
            // case ActionTypes.SET_ITINERARY_ACTIVITIES_HAS_MORE:
            //     draft.itineraryActivities.hasMore = action.hasMore;
            //     return draft;
            // case ActionTypes.SET_ITINERARY_ACTIVITIES_OFFSET:
            //     draft.itineraryActivities.offset = action.offset;
            //   return draft;
            case ActionTypes.SET_ITINERARY_ACTIVITIES_PROMOPRICES:
                draft.itineraryActivities.promoPrices = action.promoPrices;
                return draft;
            // Category Activities
            case ActionTypes.SET_CATEGORY_PRELOADED:
                draft.categoryActivities.preloaded = action.preloaded.items;
                draft.categoryActivities.isPreloadedVisible = action.preloaded.isVisible;
                draft.categoryActivities.total = action.preloaded.total;
                return draft;
            case ActionTypes.FETCH_CATEGORY_ACTIVITIES_STARTED:
                draft.categoryActivities.isLoading = true;
                draft.categoryActivities.isError = false;
                draft.categoryActivities.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_CATEGORY_ACTIVITIES_SUCCESSFULLY:
                draft.categoryActivities.isLoading = false;
                draft.categoryActivities.isLoaded = !action.res.hasMore;
                draft.categoryActivities.list = action.res.items;
                draft.categoryActivities.offset = action.res.offset;
                draft.categoryActivities.hasMore = action.res.hasMore;
                return draft;
            case ActionTypes.FETCH_CATEGORY_ACTIVITIES_FAILED:
                draft.categoryActivities.isLoading = false;
                draft.categoryActivities.isError = true;
                draft.categoryActivities.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_CATEGORY_ACTIVITIES_CANCELLED:
                draft.categoryActivities.isLoading = false;
                return draft;
            // case ActionTypes.SET_CATEGORY_ACTIVITIES_IS_LOADED:
            //     draft.categoryActivities.isLoaded = action.isLoaded;
            //     return draft;
            // case ActionTypes.SET_CATEGORY_ACTIVITIES_HAS_MORE:
            //     draft.categoryActivities.hasMore = action.hasMore;
            //     return draft;
            // case ActionTypes.SET_CATEGORY_ACTIVITIES_OFFSET:
            //     draft.categoryActivities.offset = action.offset;
            //     return draft;
            // Destination Activities
            case ActionTypes.SET_DESTINATION_PRELOADED:
                draft.destinationActivities.preloaded = action.preloaded.items;
                draft.destinationActivities.isPreloadedVisible = action.preloaded.isVisible;
                draft.destinationActivities.total = action.preloaded.total;
                return draft;
            case ActionTypes.FETCH_DESTINATION_ACTIVITIES_STARTED:
                draft.destinationActivities.isLoading = true;
                draft.destinationActivities.isError = false;
                draft.destinationActivities.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_DESTINATION_ACTIVITIES_SUCCESSFULLY:
                draft.destinationActivities.isLoading = false;
                draft.destinationActivities.isLoaded = !action.res.hasMore;
                draft.destinationActivities.list = action.res.items;
                draft.destinationActivities.offset = action.res.offset;
                draft.destinationActivities.hasMore = action.res.hasMore;
                return draft;
            case ActionTypes.FETCH_DESTINATION_ACTIVITIES_FAILED:
                draft.destinationActivities.isLoading = false;
                draft.destinationActivities.isError = true;
                draft.destinationActivities.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_DESTINATION_ACTIVITIES_CANCELLED:
                draft.destinationActivities.isLoading = false;
                return draft;
            // case ActionTypes.SET_DESTINATION_ACTIVITIES_IS_LOADED:
            //     draft.destinationActivities.isLoaded = action.isLoaded;
            //     return draft;
            // case ActionTypes.SET_DESTINATION_ACTIVITIES_HAS_MORE:
            //     draft.destinationActivities.hasMore = action.hasMore;
            //     return draft;
            // case ActionTypes.SET_DESTINATION_ACTIVITIES_OFFSET:
            //     draft.destinationActivities.offset = action.offset;
            //     return draft;
            // Recommends
            case ActionTypes.RESET_RECOMMENDS:
                draft.recommends.res = [];
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_STARTED:
                draft.recommends.isLoading = true;
                draft.recommends.isError = false;
                draft.recommends.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY:
                draft.recommends.isLoading = false;
                draft.recommends.isLoaded = true;
                draft.recommends.res = action.res;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_FAILED:
                draft.recommends.isLoading = false;
                draft.recommends.isError = true;
                draft.recommends.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_RECOMMENDS_CANCELLED:
                draft.recommends.isLoading = false;
                return draft;
            case ActionTypes.SET_RECOMMENDS_IS_LOADED:
                draft.recommends.isLoaded = action.isLoaded;
                return draft;
            // userImages
            case ActionTypes.FETCH_USER_IMAGES_STARTED:
                draft.userImages.isLoading = true;
                draft.userImages.isError = false;
                draft.userImages.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY:
                draft.userImages.isLoading = false;
                draft.userImages.isLoaded = true;
                draft.userImages.res = { ...action.res, ...draft.userImages.res };
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_FAILED:
                draft.userImages.isLoading = false;
                draft.userImages.isError = true;
                draft.userImages.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_USER_IMAGES_CANCELLED:
                draft.userImages.isLoading = false;
                return draft;
            case ActionTypes.SET_USER_IMAGES_IS_LOADED:
                draft.userImages.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default itineraryPageReducer;
